export default __webpack_public_path__ + "a992b4d673035197946e4fddfd557d38.png";